
import { BrowserModule } from '@angular/platform-browser';
import { PreloadAllModules, RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { NgModule, ErrorHandler, LOCALE_ID, Inject, inject, importProvidersFrom, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppComponent } from './app.component';
import { DynamicFormsModule } from './dynamic-forms/dynamic-forms.module';
import { SystemViewModule } from './system-view/system-view.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MyNavComponent } from './my-nav/my-nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { GlobalErrorHandler } from './services/GloabalErrorHandler.services';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthenticationFormComponent, AuthModule } from './system-utils/authentication-form/authentication-form.component';
import { SystemViewComponent } from './system-view/system-view.component';
import { AuthGuard } from './services/auth.guard.service';
import { ProdutosComponent } from './forms/produtos/produtos.component';
import { CriacaoProdutoFormComponent } from './forms/produtos/amazon/criacao-produto/criacao-produto-form/criacao-produto-form.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LogAplicacaoComponent } from './forms/log-aplicacao/log-aplicacao.component';
import { MainDashboardComponent } from './system-view/main-dashboard/main-dashboard.component';
import { PushPedidosComponent } from './forms/push-pedidos/push-pedidos.component';
import { FormulaTesterComponent } from './forms/formula-tester/formula-tester.component';
import { FormulaLabComponent } from './forms/formula-lab/formula-lab.component';
import { SimpleDatagridComponent } from './forms/simple-datagrid/simple-datagrid.component';
import { NewProductAmazonComponent } from './forms/produtos/amazon/new-product-amazon/new-product-amazon.component';
import { MeliMlbDownloadComponent } from './forms/produtos/mercadolivre/meli-mlb-download/meli-mlb-download.component';
import { ExternalAuthenticationComponent } from './forms/authentication/authentication.component';
import { IConfig, NgxMaskModule, NgxMaskPipe } from 'ngx-mask';
import { SystemComponent } from './forms/system/system.component';
import { ChangePasswordFormComponent } from './system-utils/change-password-form/change-password-form.component';
import { AnunciosComponent } from './forms/anuncios/anuncios.component';
import { ImportacaoDadosComponent } from './forms/importacao-dados/importacao-dados.component';
import { AcessViewComponent } from './forms/acess-view/acess-view.component';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { QueryExecutorComponent } from './forms/query-executor/query-executor.component';
import { MainConfiguracaoGridCardComponent } from './forms/wizard-configuracao/main-configuracao-grid-card/main-configuracao-grid-card.component';
import { CacheRouteReuseStrategy } from './system-utils/utils/cache-route-reuse.strategy';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MenuCreatorComponent } from './forms/menu-creator/menu-creator.component';
import { SharedModule } from './shared-module/shared-module.module';
import { MatTabsModule } from '@angular/material/tabs';
import { WebhookCreatorComponent } from './webhook-creator/webhook-creator/webhook-creator.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FlowModalComponent } from './forms/flow-action/flowaction.component';
import { Observable } from 'rxjs';
import { HTTPService } from './services/http.service';
import { PrintScreenAlertComponent } from './system-utils/print-screen-alert/print-screen-alert.component';
import { TranslateFormComponent } from './forms/translate-form/translate-form.component';
import { DynamicLoaderService } from './services/dynamic-loader.service';
import { ConfigJsonComponent } from './forms/json-component/config-json/config-json.component';
import { JsonImporterComponent } from './forms/json-importer/json-importer.component';
import { JsonEditorModule } from './json-editor-module/json-editor.module';
import { PrivacyComponent } from './forms/privacy/privacy.component';
import { BuilderScreenBetaModule } from './builder-screen-beta/builder-screen.module';
import { BuilderScreenBetaComponent } from './builder-screen-beta/builder-screen.component';
import { TiktokAttributeComponent } from './forms/produtos/tiktok/tiktok-attribute/tiktok-attribute.component';
import { GenericLogComponent } from './forms/generic-log/generic-log.component';
import { WebhookLogComponent } from './webhook-creator/webhook-creator/webhook-log/webhook-log.component';
import { AgentBuilderConfigComponent } from './agent-builder/agent-builder-config/agent-builder-config.component';
import { AgentBuilderModule } from './agent-builder/agent-builder.module';
import { AgentBuilderListComponent } from './agent-builder/agent-builder-list/agent-builder-list.component';
import { QuillModule } from 'ngx-quill';
import { SystemViewNewComponent } from './system-view/system-view-new/system-view-new.component';
import { SystemViewLayoutSelectorComponent } from './system-view/system-view-layout-selector.component';
import { GlobalIconeFallBackService } from './services/GlobalIconeFallBackService';
import { NZ_ICONS, NZ_ICONS_PATCH, NzIconService } from 'ng-zorro-antd/icon';
import { ConciliadoraModule } from './conciliadora/conciliadora.module';
import { ConnectionBarComponent } from './app-lost-connection-bar.component';
import { ConnectionLostBarService } from './services/ConnectionLostBarService';
import { LanguageServices } from './services/LanguageServices';
import { ShopeeAttributeComponent } from './forms/produtos/shopee/shopee-attribute/shopee-attribute.component';
import { DemoAcoesComponent } from './forms/demo-acoes/demo-acoes.component';




export class CustomTranslateLoader implements TranslateLoader {
  private httpService:HTTPService = inject(HTTPService);
  
  
  constructor(private http:HttpClient){
    
  }

  public getTranslation(languageSelected: string): Observable<any> {
      
    let obinfo = {
      "entityName":"Mktplanguage",
      "sql":`SELECT * FROM MKTPLANGUAGE`
    }         

    let observer = new Observable(observer => {
      this.httpService.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(val=>{
        let sqlRecords = val['SQL'] as Object[];
        
        let language = {};
        for( var q of sqlRecords ){
          try{
            let lang = JSON.parse(q['LANGUAGE']) as Object[];
            let trans = lang.find(d=>d['language']==languageSelected);
            Object.assign(language,{[q['ID'].toUpperCase()]:trans['text']});
          }catch(Exception){
            console.log("Problema de Traducao no campo "+q['ID']+". Erro:"+ Exception);
            Object.assign(language,{[q['ID'].toUpperCase()]:"LangError"});
          }
            
        }
        
        observer.next(language);
        switch (languageSelected) {
            case 'pt-BR':
                //observer.next(br);
                break;
            case 'en-US':
                //observer.next(en);
                break;
        }
          observer.complete();
        });
        
    });
    return observer;
  }
}



const maskConfig: Partial<IConfig> = {
  validation: false,
};


const RouterMktPlace: Routes = [
  {
    path: "changepassword",
    component: ChangePasswordFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "privacy",
    component:PrivacyComponent,
  },
  {
    path: "tempmenu",
    component: ShopeeAttributeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tempmenu3",
    component: WebhookLogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tempmenu2",
    component: MainDashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "flowaction",
    component: FlowModalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "",
    component: SystemViewLayoutSelectorComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "home",
        component: MainDashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "agentbuilder",
        component: AgentBuilderListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "ConfigJson",
        component: ConfigJsonComponent,
        canActivate: [AuthGuard],
      },
       {
        path: "JsonImporter",
        component: JsonImporterComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "authentication",
        component: ExternalAuthenticationComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "PushPedidos",
        component: PushPedidosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "produtos",
        component: ProdutosComponent,
        data: { table_name: "Mktpproducts", entityDesc: "Produtos" },
        canActivate: [AuthGuard],
      },
      {
        path: "AmazonCreator",
        component: CriacaoProdutoFormComponent,
        data: { table_name: "Mktpproducts", entityDesc: "Produtos" },
        canActivate: [AuthGuard],
      },
      {
        path: "LogFiles",
        component: LogAplicacaoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "screen-builder",
        component: BuilderScreenBetaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "FormulaTester",
        component: FormulaTesterComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "formula-lab",
        component: FormulaLabComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "WizardConfig",
        component: MainConfiguracaoGridCardComponent,//MainConfiguracaoGridComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "SimpleDatagridComponent",
        component: SimpleDatagridComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "ProductAmazon",
        component: NewProductAmazonComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "MeliDownload",
        component: MeliMlbDownloadComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "queryexecutor",
        component: QueryExecutorComponent,
        canActivate: [AuthGuard],
      },
      { path: "system", component: SystemComponent, canActivate: [AuthGuard] },
      {
        path: "anuncios",
        component: AnunciosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "importacaodados",
        component: ImportacaoDadosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "AcessView",
        component: AcessViewComponent,
        canActivate: [AuthGuard],
        data: {
          table_name: "Mktpmenuacess",
          entityDesc: "Preferências do Sistema",
        },
      },
      {
        path: "IntegrationView",
        component: MainConfiguracaoGridCardComponent,
        canActivate: [AuthGuard],
      },
      { 
        path:'WorkFlowCreator',
        component: WebhookCreatorComponent,
        canActivate: [AuthGuard]
      },
      {
        path:"MenuCreator",
        component:MenuCreatorComponent,
        canActivate: [AuthGuard]
      },
      {
        path:"translation",
        component:TranslateFormComponent,
        canActivate: [AuthGuard]
      },
      {
        // Tela antiga da conciliadora descontinuada: VAULT (conciliadora-c) e a
        // unica versao mantida. As URLs antigas redirecionam pra ela.
        path: "conciliadora-config",
        redirectTo: "conciliadora-c/config",
        pathMatch: "full"
      },
      {
        path: "conciliadora",
        redirectTo: "conciliadora-c/main",
        pathMatch: "full"
      },
      {
        path: "demo-acoes",
        component: DemoAcoesComponent,
        canActivate: [AuthGuard]
      },
      {
        // VAULT (novo layout da conciliadora) - acessivel so por URL, SEM menu.
        // Quando aprovado, basta apontar o menu pra ca. /conciliadora-c/main e /conciliadora-c/config
        path: "conciliadora-c",
        loadChildren: () => import('./conciliadora-redesign-c/conciliadora-redesign-c.module').then(m => m.ConciliadoraRedesignCModule),
        canActivate: [AuthGuard]
      },
      {
        // Tela SOMENTE-LEITURA de repasses Koncili para o cliente final.
        // Reusa HTTPService/UserAuth (tenant filtrado no KonciliRepasseService). Menu IDMENU='conciliacoes'.
        path: "conciliacoes",
        loadChildren: () => import('./conciliacoes-cliente/conciliacoes-cliente.module').then(m => m.ConciliacoesClienteModule),
        canActivate: [AuthGuard]
      },
      {
        // Separacao & Conferencia de Pedidos (picking/checking de marketplaces).
        // /separacao (fila mobile), /separacao/picking/:idwave, /separacao/conferencia/:idwave,
        // /separacao/config (desktop). Persistencia da operacao 100% via fluxos TemAPI.
        path: "separacao",
        loadChildren: () => import('./separacao-pedidos/separacao-pedidos.module').then(m => m.SeparacaoPedidosModule),
        canActivate: [AuthGuard]
      },
      {
        // Rota dedicada da CONFIGURACAO da separacao (IDMENU de 1 segmento p/
        // item de menu proprio). Redireciona para a rota filha do modulo lazy.
        path: "separacao-config",
        redirectTo: "separacao/config",
        pathMatch: "full"
      }
    ],
  },

  {
    path: "",
    component: AuthenticationFormComponent,
    children: [
      {
        path: "auth",
        component: AuthenticationFormComponent,
      },
    ],
  },
];

@NgModule({ declarations: [AppComponent, MyNavComponent,PrintScreenAlertComponent],
    exports: [
      
    ],
    bootstrap: [AppComponent], 
    
    imports: [
        MatCheckboxModule,
        BrowserModule,
        DynamicFormsModule,
        BrowserAnimationsModule,
        MatToolbarModule,
        MatSidenavModule,
        MatProgressSpinnerModule,
        LayoutModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatIconModule,
        MatListModule,
        MatProgressBarModule,
        MatDialogModule,
        MatSlideToggleModule, 
        NgxDatatableModule,
        MatCardModule,
        SharedModule,
        SystemViewModule,
        MatTableModule,
        MatMenuModule,
        AuthModule,
        FormsModule,
        MatTabsModule,   
        JsonEditorModule,
        BuilderScreenBetaModule,
        AgentBuilderModule,
        ConciliadoraModule,
        ConnectionBarComponent,
        QuillModule.forRoot(),
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader, useClass: CustomTranslateLoader, deps: [HttpClient]
          }

        }),
        RouterModule.forRoot(RouterMktPlace, {
            preloadingStrategy: PreloadAllModules,
            //relativeLinkResolution: "legacy",
        }),
        LazyLoadImageModule,
        NgxMaskModule.forRoot(maskConfig),
        FontAwesomeModule], 
        providers: [
          LanguageServices,
         //{ provide: NZ_ICONS, useValue: [] },
        //{ provide: NZ_ICONS_PATCH, useValue: [] },
        //{ provide: NzIconService, useClass: GlobalIconeFallBackService },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        {
            provide: RouteReuseStrategy,
            useClass: CacheRouteReuseStrategy
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                subscriptSizing: 'dynamic',
                appearance: 'outline'
            }
        },
        NgxMaskPipe,
        provideHttpClient(withInterceptorsFromDi()),
        DynamicLoaderService,
        ConnectionLostBarService
    ] })
export class AppModule {}
